<template>
  <div>
    <div class="home">
      <div class="home-banner">
        <img src="@/assets/img/index/banner1.png">
        <div class="content">
          智慧会展创造者、先行者及领导者
        </div>
      </div>
      <div class="card-row">
        <div class="card">
          <img src="@/assets/img/index/areas1.png">
          <div class="newNavHead"></div>
          <div class="mask"></div>
          <div class="newNavContent">
            <p>平台服务</p>
            <router-link to="/service#platform">
              <span>查看详情</span>
              <span class="arrowDetail"></span>
            </router-link>
          </div>
        </div>
        <div class="card">
          <img src="@/assets/img/index/areas2.png">
          <div class="newNavHead"></div>
          <div class="mask"></div>
          <div class="newNavContent">
            <p>人才网络</p>
            <router-link to="/service#network">
              <span>查看详情</span>
              <span class="arrowDetail"></span>
            </router-link>
          </div>
        </div>
        <div class="card">
          <img src="@/assets/img/index/areas3.png">
          <div class="newNavHead"></div>
          <div class="mask"></div>
          <div class="newNavContent">
            <p>智能会议</p>
            <router-link to="/service#meeting">
              <span>查看详情</span>
              <span class="arrowDetail"></span>
            </router-link>
          </div>
        </div>
      </div>
      <div>
        <div style="text-align: center;">
          <div class="title">
            <div class="line1"></div>
            <div class="letter">S</div>
            <div class="txt">
              <div>服务网络</div>
              <div class="sub-title">ervice Network</div>
            </div>
            <div class="line2"></div>
          </div>
        </div>
        <div class="city-title">
          <span>300+</span>国内城市，
          <span>32</span>个国际热点国家与地区服务覆盖
        </div>
        <div class="city-title">
          <span>4</span>个中心（北京、上海、成都、广州），
          <span>10000+</span>本地化人才网络成员
        </div>
        <Map/>
      </div>
      <div>
        <div style="text-align: center;">
          <div class="title">
            <div class="line1"></div>
            <div class="letter">S</div>
            <div class="txt">
              <div>服务客户</div>
              <div class="sub-title">ervice customer</div>
            </div>
            <div class="line2"></div>
          </div>
        </div>
        <div class="service">
          <swiper :options="serviceSwiper" ref="serviceSwiper">
            <swiper-slide v-for="(slide, index) in serviceSwiperChildren" :key="index">
              <img
                v-for="item in slide"
                :key="item"
                :src="require(`@/assets/img/index/customer/${item}.png`)"
              >
            </swiper-slide>
            <div class="swiper-button-prev swiper-button-prevs" slot="button-prev"></div>
            <div class="swiper-button-next swiper-button-nexts" slot="button-next"></div>
          </swiper>
        </div>
      </div>
      <div>
        <div style="text-align: center;">
          <div class="title">
            <div class="line1"></div>
            <div class="letter">P</div>
            <div class="txt">
              <div>合作伙伴</div>
              <div class="sub-title">artner</div>
            </div>
            <div class="line2"></div>
          </div>
        </div>
        <div class="partner">
          <swiper :options="partnerSwiper" ref="partnerSwiper">
            <swiper-slide v-for="(slide, index) in partnerSwiperChildren" :key="index">
              <div>
                <img
                  v-for="item in slide"
                  :key="item"
                  :src="require(`@/assets/img/index/partner/${item}.png`)"
                >
              </div>
            </swiper-slide>
            <div class="swiper-button-prev swiper-button-prev-old" slot="button-prev"></div>
            <div class="swiper-button-next swiper-button-next-old" slot="button-next"></div>
          </swiper>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
// @ is an alias to /src
import Footer from "@/components/Footer";
import Map from "@/views/Home/map1.vue";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  name: "home",
  components: {
    Footer,
    swiper,
    swiperSlide,
    Map
  },
  data() {
    return {
      swiperOption: {
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        loop: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      serviceSwiper: {
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        loop: true,
        navigation: {
          nextEl: ".swiper-button-nexts",
          prevEl: ".swiper-button-prevs"
        }
      },
      partnerSwiper: {
        loop: true,
        navigation: {
          nextEl: ".swiper-button-next-old",
          prevEl: ".swiper-button-prev-old"
        }
      },
      serviceSwiperChildren: [],
      partnerSwiperChildren: [],
      honorSwiperChildren: [
        "香港会展局佳绩奖",
        "最具创新力PCO",
        "MICE三亚最佳贡献奖",
        "2016 商务会奖旅游 金椅子奖",
        "南京会奖旅游顾问单位",
        "2016年度会奖旅游金椅子奖",
        "2011年度BestPCO",
        "2018 商务会奖旅游 金椅子奖",
        "国家旅业榜",
        "奇迹奖 最佳Event",
        "绿色会展联盟会员",
        "中国会议产业大会华表奖",
        "MICE亚太协会会员",
        "中国最具竞争力品牌",
        "云南MICE风云榜TOP10",
        "奇迹奖 最佳PCO",
        "国家高新企业证书",
        "文创企业信促会证书",
        "中关村高新企业证书"
      ],
      screenWidth: document.body.clientWidth,
      timer: false
    };
  },
  methods: {
    imgPush(max, imgNum, number) {
      let arr = [];
      let item = [];
      for (let i = 1; i < max + 1; i++) {
        if (i % imgNum) {
          if (i > number) {
            item.push(i - number);
          } else item.push(i);
        } else {
          if (i > number) {
            item.push(i - number);
          } else item.push(i);
          arr.push(item);
          item = [];
        }
      }
      return arr;
    },
    initData() {
      let screenW = document.body.clientWidth;
      if (screenW <= 997) {
        var imgNum1 = 20;
        var max1 = 80;
        var imgNum2 = 15;
        var max2 = 45;
      } else {
        var imgNum1 = 32;
        var max1 = 96;
        var imgNum2 = 24;
        var max2 = 48;
      }
      this.serviceSwiperChildren = this.imgPush(max1, imgNum1, 72);
      this.partnerSwiperChildren = this.imgPush(max2, imgNum2, 42);
    }
  },
  created() {
    this.initData();
  },
  mounted() {
    const that = this;
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth;
        that.screenWidth = window.screenWidth;
      })();
    };
  },
  watch: {
    screenWidth(val) {
      let that = this;
      this.screenWidth = val;
      that.$refs.serviceSwiper.swiper.destroy(); //先销毁
      that.$refs.serviceSwiper.mountInstance(); //后在加载
      that.$refs.partnerSwiper.swiper.destroy(); //先销毁
      that.$refs.partnerSwiper.mountInstance(); //后在加载
      that.initData();
    }
  }
};
</script>
<style lang="less" scoped>
@import "../../less/home.less";
</style>
